import { useState, useCallback, useMemo, useEffect } from 'react';
import Router, { useRouter, getQueryString } from '@/Framework/Router';
import { toSlug } from '@/Framework/url/helpers/toSlug';
import AssetClass, { ABS } from '@/finsight/domain/AssetClass';
import URL from '@/finsight/Router/urlConstants';
import { IAssetClass } from '@/finsight/domain/vo/IAssetClass';

export default function useAssetsClasses(initial?: IAssetClass[]) {
  const [assetsClasses, setAssetsClasses] = useState<IAssetClass[]>(initial || []);

  const { query: { bondType, assetClass, products, regions } } = useRouter();
  const [
    currentAssetClass,
    setCurrentAssetClass,
  ] = useState<IAssetClass | null>(AssetClass.getByAbbreviation(assetsClasses, assetClass as string));
  const search = getQueryString({ products, regions });

  useEffect(() => {
    if (assetsClasses?.length) {
      const routeAssetClass = assetClass as string;
      if (AssetClass.isValid(assetsClasses, routeAssetClass)) {
        setCurrentAssetClass(
          AssetClass.getByAbbreviation(assetsClasses, routeAssetClass),
        );
        return;
      }
      Router.replace(`${ URL.BONDS_SUMMARY_BASE }-${ bondType }-${ ABS }`, undefined, { shallow: true });
    }
  }, [assetsClasses, assetClass]);

  useEffect(() => setAssetsClasses(initial), []);

  const handleAssetClassClick = useCallback((assetClass) => {
    const sluggedAssetClassAbbr = toSlug(assetClass.abbreviation);
    if (sluggedAssetClassAbbr !== assetClass) {
      Router.replace(
        `${ URL.BONDS_SUMMARY_BASE }-${ bondType }-${ toSlug(assetClass.abbreviation) }?${ search }`,
      );
    }
  }, [assetClass, bondType]);

  return useMemo(() => ({
    assetsClasses,
    setCurrentAssetClass,
    handleAssetClassClick,
    currentAssetClass,
  }), [
    assetsClasses,
    handleAssetClassClick,
    currentAssetClass,
  ]);
}
